(function () {
    var VideoFlip = function (videoContainer, type) {
        this.originalVideo = videoContainer;
        this.type = type;
    };

    VideoFlip.prototype.flip = function () {
        var _this = this;
        this.fiveMinVideo = $("<div class='five-min-container'></div>");

        var divTag = document.createElement('div');
        divTag.className = 'vdb_player vdb_' + HPPOST.playerID + HPPOST.companyID;

        var scriptTag = document.createElement('script');

        var bid = '';
        if(HPPOST.playListID) {
            bid = '/bid=' + HPPOST.playListID;
        }
        scriptTag.src = '//delivery.vidible.tv/jsonp' + bid + '/pid=' + HPPOST.playerID + '/' + HPPOST.companyID + '.js';

        divTag.appendChild(scriptTag);

        var backToOriginal = $("<a class='back-to-original' href='javascript:void(0)'>&lt; Back to " + this.type + " video</a>");
        backToOriginal.on("click", function () {
            _this.returnToOriginal();
        });

        this.fiveMinVideo.append(divTag, backToOriginal).insertBefore(this.originalVideo);
        this.originalVideo.css("display", "none");
    };

    VideoFlip.prototype.returnToOriginal = function () {
        this.originalVideo.css("display", "block");
        this.fiveMinVideo.remove();
        delete this.fiveMinVideo;
    };

    // expose to global instance
    window.MW.modules.VideoFlip = VideoFlip;
}());

(function () {
    var youtubeFlips = {};

    var onYouTubeVideoReady = function (stateData) {
        // We have to adjust the iframe that youtube generates
        // in order to support flex video:
        var iframe = $(stateData.target.getIframe());
        iframe.removeAttr('width');
    };

    var onYouTubeVideoStateChange = function (stateData) {
        var iframe = $(stateData.target.getIframe()),
            youtubeId = iframe.attr("data-youtube-id").toString();

        // NB: Athena returns the youtube iframe with a responsive div
        // around it.  In this case, make the responsive div the target
        // instead of the iframe itself
        if (iframe.parent() && iframe.parent().height() <= 0) {
            iframe = iframe.parent();
        }

        // If they've reached the end of the youtube video,
        // drop in the 5min player and add a link to allow them
        // to get the YouTube video back
        if (stateData.data === 0) {
            var flipVideo = new window.MW.modules.VideoFlip(iframe, "YouTube");
            flipVideo.flip();
        }
    };

    hpYoutube.apiReady().then(function () {
        $(".video-flip.youtube").each(function (index, flipContainer) {
            var youtubeId = $(flipContainer).attr("data-youtube-id");
            var autoplay = $(flipContainer).attr("data-youtube-autoplay");
            var mute = $(flipContainer).attr("data-youtube-mute");

            youtubeFlips[youtubeId] = new window.YT.Player('youtube-flip-' + youtubeId, {
                videoId: youtubeId,
                events: {
                    'onStateChange': onYouTubeVideoStateChange,
                    'onReady': onYouTubeVideoReady
                },
                playerVars: {
                    'autoplay': autoplay,
                    'mute': mute
                },
            });
        });

        if($("#ytplayer").length) {
            youtubeplayer = new YT.Player('ytplayer', {
                events: {
                    'onStateChange': onYoutubePlayerStateChangeVideoEntry
                }
            });
        }
    });
}());
